import { SharePointSite } from '../../microsoft/sharepoint/share-point-site';

export class SharePointSiteInformation {
  ownerHasFullControl: boolean;
  farmSummaryItems: SharePointSite[];
}
